import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { ErrorBoundary } from "@/components/app/ErrorBoundary";
import { ConfirmProvider } from "@/components/app/ConfirmDialog";
import { Toaster } from "@/components/ui/sonner";

import NotFound from "./pages/NotFound";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import { AppLayout } from "@/components/app/AppLayout";

import ProductLibrary from "./pages/app/ProductLibrary";
import ProductWorkspace from "./pages/app/ProductWorkspace";
import AssetLibrary from "./pages/app/AssetLibrary";
import StudioPage from "@/pages/app/StudioPage";
import WorkspaceSettings from "./pages/app/WorkspaceSettings";
import EditVisualPage from "./pages/app/EditVisualPage";

import ShareView from "./pages/public/ShareView";
import InviteAccept from "./pages/public/InviteAccept";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <ConfirmProvider>
      {/* Nothing rendered these before, so every toast() in the app was
          invisible. */}
      <Toaster />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* App (Protected) */}
            <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/app/studio" replace />} />
              <Route path="products" element={<ProductLibrary />} />
              <Route path="products/new" element={<ProductWorkspace />} />
              <Route path="products/:productId" element={<ProductWorkspace />} />
              <Route path="studio" element={<StudioPage />} />
              <Route path="asset-library" element={<AssetLibrary />} />
              <Route path="edit-visual" element={<EditVisualPage />} />
              <Route path="settings" element={<WorkspaceSettings />} />
            </Route>

            {/* Public routes */}
            <Route path="/share/:token" element={<ShareView />} />
            <Route path="/invite/:token" element={<InviteAccept />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </ConfirmProvider>
    </TooltipProvider>
  </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
